<template>
	<img src="/images/common/loading_great_pro.gif" width="120" height="120" style="object-fit:scale-down"/>
</template>

<script>
export default {
	props : ['param'],
	data() {
		return {
		};
	},
	methods: {
	},
	computed: {
	}
};
</script>